<h1 mat-dialog-title>{{ 'offer.picture.gallery.value' | translate }}</h1>
<mat-dialog-content>
    <app-core-offer-picture-gallery [offer]="offer"></app-core-offer-picture-gallery>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="row x_center">
        <button class="btn_cta btn_little btn_red" (click)="close()">{{ 'notification.close.action.value' | translate }}</button>
    </div>
</mat-dialog-actions>
